/**
 * Controla el diálogo de rechazar tarea.
 */
TareasFinalizarDialogCtrl.$inject = ['$log', '$scope', '$http', 'CampoExtra', '$q'];
export default function TareasFinalizarDialogCtrl($log, $scope, $http, CampoExtra, $q) {

    var URL_TAREAS_BASE = Sigo.var.path + '/obras';

    var tarFinCtr = this;

    var dialog = $scope.dialog;
    var tareaId = $scope.model.id;
    var codigos = $scope.model.codigos;
    var noHayNada = issetAndNotEmpty($scope.model.noHayNada) ? $scope.model.noHayNada : false;

    tarFinCtr.tareaId = tareaId;
    tarFinCtr.multiple = !issetAndNotEmpty(tareaId) || tareaId == null || !isNumeric(tareaId);

    tarFinCtr.fechaFinalizacion = moment().format("DD/MM/YYYY HH:mm");
    tarFinCtr.numeroImagenes = 0;
    tarFinCtr.mostrar_fecha_finalizacion = Sigo.config['tareas_solicitar_fecha_finalizacion'];
    tarFinCtr.loading = false;

    tarFinCtr.imagenes = [];

    tarFinCtr.camposExtra = [];
    tarFinCtr.updateActive = true;
    tarFinCtr.puedeEditarCamposExtra = Sigo.user.puedeEditarCamposExtra;

    var esAdminOSAdmin = Sigo.user.esAdmin || Sigo.user.esSAdmin;
    tarFinCtr.imagenObligatoria = Sigo.config['proyecto'] === "peniscola" && !esAdminOSAdmin;

    var finalizarTarea = function () {
        var data = {
            fecha_finalizacion: tarFinCtr.fechaFinalizacion
        };

        var url = noHayNada ? '/no-hay-nada-con-fecha/' + tareaId : '/finalizar-con-fecha/' + tareaId;

        return $http.post(URL_TAREAS_BASE + url, data);
    };

    var finalizarTareas = function () {
        var data = {
            codigos: codigos,
            fecha_finalizacion: tarFinCtr.fechaFinalizacion
        };

        var respuestaCorrecta = function (data) {
            Sigo.UI.Messages.procesarRespuestaMultiplesAcciones(data.data);
        };

        var url = noHayNada ? '/no-hay-nada-varias' : '/finalizar-varias';

        var promesa = $http.post(URL_TAREAS_BASE + url, data);

        promesa.then(respuestaCorrecta);

        return promesa;
    };

    if (tarFinCtr.puedeEditarCamposExtra) cargarCamposExtra();

    tarFinCtr.anyadirImagenes = function () {
        if (issetAndNotEmpty(tareaId)) {
            Adjuntos.openDialogAddFiles(tareaId, 'tareas').then(function (data) {
                tarFinCtr.numeroImagenes = data.numeroImagenes;

                for (var i = 0; i < data.uploadFiles.length; i++) {
                    tarFinCtr.imagenes.push(data.uploadFiles[i]);
                }

                $scope.$apply();

            });
        }
    };

    tarFinCtr.generateImgUrl = function (img) {
        return Sigo.var.path + '/uploads/imagenes/' + img + '_thumb.jpg'
    };

    tarFinCtr.cancelar = function () {
        dialog.cancel();
    };

    function cargarCamposExtra() {
        if (tarFinCtr.puedeEditarCamposExtra && issetAndNotEmpty(tareaId) && !noHayNada) {
            tarFinCtr.loading = true;
            CampoExtra.get(tareaId, true)
                .then(function (data) {
                    tarFinCtr.camposExtra = data.data;
                    tarFinCtr.loading = false;
                }, function () {
                    tarFinCtr.loading = false;
                });
        } else {
            tarFinCtr.loading = false;
        }
    }

    function actualizarCamposExtra() {
        var promesas = [];

        for (var i = 0; i < tarFinCtr.camposExtra.length; i++) {
            var campoExtra = tarFinCtr.camposExtra[i];
            if (issetAndNotEmpty(campoExtra.changed) && campoExtra.changed) {
                promesas.push(
                    campoExtra.valor != null
                        ? CampoExtra.update(tareaId, {campoExtraId: campoExtra.id, valor: campoExtra.valor})
                        : CampoExtra.delete(tareaId, campoExtra.id)
                );
            }
        }

        return $q.all(promesas);
    }

    tarFinCtr.finalizarTarea = function () {
        if (!tarFinCtr.loading) {
            tarFinCtr.loading = true;

            var formularioCorrecto = true;
            if (tarFinCtr.imagenObligatoria) {
                var hayImagenes = tarFinCtr.numeroImagenes > 0;

                if (!hayImagenes) {
                    Sigo.UI.Messages.open([Lang.get('mensajes.imagen_obligatoria')], false);
                    formularioCorrecto = false;
                }
            }

            if (tarFinCtr.mostrar_fecha_finalizacion) {
                if (!moment(tarFinCtr.fechaFinalizacion, "DD/MM/YYYY").isValid()) {
                    Sigo.UI.Messages.open([Lang.get('mensajes.escribir_fecha_valida')], 0);
                    formularioCorrecto = false;
                }
            }

            for (var i = 0; i < tarFinCtr.camposExtra.length; i++) {
                var campoExtra = tarFinCtr.camposExtra[i];
                if (typeof campoExtra.valor == 'undefined' || campoExtra.valor == null
                    || (typeof campoExtra.valor == 'string' && campoExtra.valor == '')
                    || (campoExtra.tipo_campo == 'number' && isNaN(campoExtra.valor))) {
                    Sigo.UI.Messages.open([Lang.get('mensajes.msg_camp_extr_oblg')], 0);
                    formularioCorrecto = false;
                }
            }

            if (formularioCorrecto) {
                actualizarCamposExtra().then(function () {
                    var promesa = tarFinCtr.multiple ? finalizarTareas() : finalizarTarea();

                    promesa.then((data) => {
                        dialog.close(data);
                    }, (error) => {
                        tarFinCtr.loading = false;
                        console.log(error);
                        if (typeof error.data.message !== "undefined")
                            Sigo.UI.Messages.open([error.data.message], 0);
                        dialog.close();
                    });
                });
            } else {
                tarFinCtr.loading = false;
            }
        }
    };
}